import { isFilePathTarget } from './linkify'

/**
 * Classify markdown link targets for click dispatch.
 * File paths are handled by onFileClick; everything else is treated as a URL.
 * file:// URLs and absolute/home paths are file targets regardless of extension
 * (directories, .xlsx, .mp4, ...) — the file handler opens what it can't preview
 * in the default app. Relative paths still need a known extension.
 */
export function classifyMarkdownLinkTarget(target: string): 'file' | 'url' {
  if (target.startsWith('file://')) return 'file'
  if (/^(?:\/(?!\/)|~\/)/.test(target)) return 'file'
  return isFilePathTarget(target) ? 'file' : 'url'
}
